import { useState } from "react";
import { ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

async function savePhoto(url: string, name: string) {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("download failed");
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = name;
    link.click();
    URL.revokeObjectURL(objectUrl);
  } catch {
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    link.target = "_blank";
    link.rel = "noopener";
    link.click();
  }
}

export function QcPhotoViewer({
  urls,
  index,
  title,
  onClose,
  onDelete,
  onReplace,
}: {
  urls: string[];
  index: number;
  title: string;
  onClose: () => void;
  onDelete?: (index: number) => void;
  onReplace?: (file: File, index: number) => void;
}) {
  const [current, setCurrent] = useState(index);
  const url = urls[current] ?? urls[0];
  if (!url) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" role="dialog" aria-modal="true" aria-label={title}>
      <div className="max-h-[90vh] w-full max-w-3xl space-y-3 overflow-auto rounded-2xl bg-white p-4 dark:bg-zinc-900">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <p className="text-sm font-semibold text-gray-900 dark:text-zinc-100">{title}</p>
          <button type="button" className={ghostBtnClass} onClick={onClose}>Close</button>
        </div>
        <img src={url} alt={title} className="max-h-[70vh] w-full rounded-lg object-contain" />
        <div className="flex flex-wrap items-center gap-2">
          {urls.length > 1 ? (
            <>
              <button type="button" className={ghostBtnClass} disabled={current <= 0} onClick={() => setCurrent((value) => value - 1)}>
                Previous
              </button>
              <span className="text-sm text-gray-900 dark:text-zinc-100">{current + 1} of {urls.length}</span>
              <button type="button" className={ghostBtnClass} disabled={current + 1 >= urls.length} onClick={() => setCurrent((value) => value + 1)}>
                Next
              </button>
            </>
          ) : null}
          <button type="button" className={ghostBtnClass} onClick={() => void savePhoto(url, "qc-failure.jpg")}>
            Download
          </button>
          {onReplace ? (
            <label className={`${ghostBtnClass} inline-flex cursor-pointer`}>
              Replace
              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                className="hidden"
                onChange={(event) => {
                  const file = event.target.files?.[0];
                  event.target.value = "";
                  if (file) onReplace(file, current);
                }}
              />
            </label>
          ) : null}
          {onDelete ? (
            <button type="button" className={ghostBtnClass} onClick={() => onDelete(current)}>Delete</button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
